import React, { Component } from "react";

class MainHeader extends Component {

    constructor() {
        super();
    }

    componentDidMount() {}

    render() {

        const environment_url = window.location.origin;

        return (
                <header class="">
                    <div class="top-bar top-bar-bg">
                        <div class="container-fluid">
                            <div class="row">
                            <div class="col-sm-12 text-center">
                                    <div class="top-message">
                                        <p><a href={environment_url+"/pt/registar-gratis/"} class="sign-link">Divulgue a sua instituição aqui, registe-se GRÁTIS!</a></p>
                                    </div>
                                    <div class="user-access">
                                        <span><img src="img/icon/lock-icon.svg" alt="icon-user" /><a title={localStorage.name ? localStorage.name : "Área reservada"} href={environment_url+"/pt/area-reservada/"} class="sign-link">{localStorage.name ? localStorage.name : "Área reservada"}</a></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="logo-area">
                        <div class="container-fluid">
                            <div class="row align-items-center">
                                <div class="col-md-3">
                                    <div class="logo-box">
                                        <a href={environment_url} class="logo-link">
                                            <img src="img/logo-laresonline.svg" alt="logo-laresonline" />
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-9 d-flex align-items-center justify-content-end logo-middile">
                                    <a href={environment_url+"/pt/pedido-de-ajuda/"} alt="admissão-de-idosos"><span class="call-text">Admissão de Idosos?</span></a>
                                    {/*
                                      <div class="contact-info">
                                        <span class="call-btn"><a href="tel:00351939667800" class="number" alt="Ligue (+351) 939 667 800">Ligue (+351) 939 667 800 </a></span>
                                        <span class="icon"><img src="img/telephone-handle-silhouette.svg" alt="icon-telefone" /></span>
                                      </div>
                                    */}
                                </div>
                                <div class="col-12">
                                    <div class="mobile-menu"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header> 
            )
        }
    }

export default MainHeader;
